import { useEffect, useState } from "react";
import axios from "axios";

import { useAuth0 } from "../react-auth0-spa";
import { API_URL } from "../../constants/constants";

export const usePostPaquetes = () => {
  const [body, setBody] = useState(null);
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { getTokenSilently, user } = useAuth0();

  useEffect(() => {
    if (!body) return;
    const postDireccion = async () => {
      setIsError(false);
      setIsLoading(true);
      try {
        const { nombre, alto, ancho, largo, contenido, peso } = body;
        const t = await getTokenSilently();
        const r = await axios.post(
          API_URL + `/paquetes/${user.sub}`,
          {
            nombre,
            alto: Number(alto),
            ancho: Number(ancho),
            largo: Number(largo),
            peso: Number(peso),
            contenido
          },
          {
            headers: {
              // "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${t}`
            }
          }
        );
        setData(r.data);
        // console.log(r.data);
      } catch (error) {
        console.log(error);
        setIsError(true);
      }
      setIsLoading(false);
    };
    postDireccion();
  }, [body,getTokenSilently,user.sub]);

  return [{ data, isLoading, isError }, setBody];
};

export default usePostPaquetes;
